<script>
import ChallengeQuizz from './ChallengeQuizz'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  components: {
    ChallengeQuizz
  },

  data() {
    return {
      loading: true,
      quizz_opened: false,
      time_left: null,
      time_interval: null
    }
  },

  created() {
    this.$store.dispatch('getOngoingChallenge')
      .then(() => (this.loading = false))
  },

  computed: {
    ...mapState([
      'ongoing_challenge'
    ]),

    challenge() {
      this.setOngoingChallenge(this.ongoing_challenge)
      return this.ongoing_challenge
    }
  },

  methods: {
    setOngoingChallenge(challenge) {
      if (challenge) {
        this.updateTimeLeft(challenge)
        this.time_interval = setInterval(this.updateTimeLeft.bind(this, challenge), 1000)
      }
    },

    updateTimeLeft(challenge) {
      var end = moment(challenge.pivot.ended_at)
      var today = moment()

      if (end.diff(today) < 0) {
        this.time_left = '00<small>H</small> 00<small>M</small> 00<small>S</small>'
        this.$store.commit('setOngoingChallenge', null)
        this.$store.commit('setFinishedChallenge', challenge)
        clearInterval(this.time_interval)
      } else {
        var hours = end.diff(today, 'hours')
        var minutes = end.subtract(hours, 'hours').diff(today, 'minutes')
        var seconds = end.subtract(minutes, 'minutes').diff(today, 'seconds')

        this.time_left = `
          ${hours > 9 ? hours : '0' + hours}<small>H</small>
          ${minutes > 9 ? minutes : '0' + minutes}<small>M</small>
          ${seconds > 9 ? seconds : '0' + seconds}<small>S</small>
        `
      }
    }
  }
}
</script>

<template>
  <div class="Challenge-box" v-show="!loading">
    <button class="button is-info"
      @click="quizz_opened = true"
      v-show="!challenge">
      {{ $t('buttons.start_challenge') }}
    </button>

    <router-link class="button is-warning is-size-5"
      :to="{name: 'challenge', params: {id: challenge.slug}}"
      tag="button"
      v-if="challenge">
      Défi en cours <br>
      <time v-html="time_left"></time>
      <span>restant</span>
    </router-link>

    <challenge-quizz
      v-if="quizz_opened"
      @close="quizz_opened = false" />
  </div>
</template>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/all';

.Challenge-box {
  position: fixed;
  z-index: 100;
  right: pxToEm(10);
  bottom: pxToEm(10);
}

.button {
  font-weight: 500;

  &.is-warning {
    display: block;
    height: auto;
    min-height: auto;

    time,
    span {
      display: block;
    }

    time {
      font-size: $font-size-ml;
    }

    span {
      font-size: $font-size-xs;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ChallengeBox.vue?7cfba0bd